/* eslint-disable */
import Toast from '@js/modules/toast/index';
import Tab from '@js/modules/tab/index';
import StepNumberes from '@js/modules/number/index';
import EmblaSlider from '@js/modules/embla/index';
import DocumentLinks from '@js/modules/documentLink/index';
import FileUpload from '@js/modules/fileUpload/index';
import Modal from '@js/modules/modal/index';
import Accordion from '@js/modules/accordion/index';
import LinkScroll from '@js/modules/linkScroll/index';
import DuplicationCheck from '@js/modules/duplicationCheck/index';
import PageLoading from '@js/modules/pageLoading/index';
import ApplicationPolling from '@js/modules/applicationPolling/index';
import InvestorRegistrationModal from '@js/modules/investorRegistrationModal/index';
import InvestorRegistrationLink from '@js/modules/investorRegistrationLink/index';
import PrivacyConsentScroll from '@js/modules/privacyConsentScroll/index';
import ConsentStateManager from '@js/modules/consentStateManager/index';
import Simulation from '@js/modules/simulation/index';
import Rails from '@rails/ujs';
Rails.start();

// stimulus
import { Application } from '@hotwired/stimulus';
import { registerControllers } from '@js/utils/stimulus';

const application = Application.start();
const controllers = import.meta.glob('../javascripts/controllers/customer/**/*_controller.js', { eager: true });
registerControllers(application, controllers);

new Toast().attachEvent();
new Toast().restoreFlashMessage(); // フラッシュメッセージ復元
new Tab().attachEvent();
new StepNumberes().attachEvent();
new EmblaSlider().detailsAttachEvent();
new DocumentLinks().attachEvent();
new FileUpload().attachEvent();
new Modal().attachEvent();
new Accordion().attachEvent();
new LinkScroll().attachEvent();
new DuplicationCheck().attachEvent();
new PageLoading().attachEvent();
new ApplicationPolling().attachEvent();
// 出資者情報登録の同意・承諾処理（管理画面設定により切り替え）
// data-use-modal属性でモーダル表示 or 別ウィンドウ表示を判定
const consentWrapper = document.querySelector('[data-use-modal]');
if (consentWrapper) {
  const useModal = consentWrapper.getAttribute('data-use-modal') === 'true';
  if (useModal) {
    // モーダル表示：同じページ内でモーダルを開いて確認
    new InvestorRegistrationModal().attachEvent();
  } else {
    // 別ウィンドウ表示：新しいタブで確認書面を開く
    new InvestorRegistrationLink().attachEvent();
  }
}
// 個人情報の取扱いについての同意のスクロール監視
new PrivacyConsentScroll().attachEvent();
// 同意・承諾プロセス全体のコーディネーター（送信ボタン制御）
new ConsentStateManager().attachEvent();
new Simulation().attachEvent();
new Simulation().openSimulationAccordion();

import Stickyfill from 'stickyfilljs';
if(document.querySelector('.sticky')) {
  const stickyElments = document.querySelectorAll('.sticky');
  Stickyfill.add(stickyElments);
}
window.fbAsyncInit = function() {
  FB.init({
    cookie     : true,
    xfbml      : true
  });

  FB.AppEvents.logPageView();

  FB.logout(function(response) {
    // Person is now logged out
  });
  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
};
